import { matchRoutes } from 'react-router-dom';

import type { RouteDefinition, RouterQuery } from './types';

export interface ClientRouteLocation {
	params: Readonly<Record<string, string | undefined>>;
	route: RouteDefinition;
}

export function resolveClientRouteLocation(
	pathname: string,
	fallback: ClientRouteLocation,
	routes: readonly RouteDefinition[]
): ClientRouteLocation {
	const match = matchRoutes(
		routes.map((route) => ({ handle: route, path: route.reactPath })),
		pathname
	)?.at(-1);
	const matchedRoute = match?.route.handle;

	return matchedRoute ? { params: match?.params ?? {}, route: matchedRoute } : fallback;
}

export function queryFromRouteLocation(
	search: string,
	params: Readonly<Record<string, string | undefined>>,
	route: RouteDefinition
): RouterQuery {
	const query: RouterQuery = {};
	for (const [key, value] of new URLSearchParams(search).entries()) {
		const existing = query[key];
		query[key] = existing === undefined ? value : Array.isArray(existing) ? [...existing, value] : [existing, value];
	}

	for (const [key, value] of Object.entries(params)) {
		if (key === '*') {
			if (route.splatParam && value) query[route.splatParam] = value.split('/');
		} else if (value !== undefined) {
			query[key] = value;
		}
	}

	return query;
}
